<template>
  <section>
    <Spinner :isLoading="isLoading" />
    <div class="edit">
      <div class="d-flex align-items-center">
        <AvatarPreview :photo="selectedAvatrar" v-on:new="reGetProfile" />
        <div class="text">
          <h1 v-if="!isInEditMode">
            {{ getUserProfile.first_name }} {{ getUserProfile.last_name }}

            <span v-if="editButton" @click="toggleEdit()">
              <i class="fas fa-pen"></i>
            </span>
          </h1>
          <div v-if="isInEditMode" class="d-flex">
            <input v-model="editFirstName" type="text" class="form-control mr-2" />
            <input v-model="editLastName" type="text" class="form-control mr-3" />
            <div class="buttons ms-auto" style="flex-shrink: 0">
              <button title="Save changes" @click="editProfile" class="btn btn-primary mr-3">
                Save
              </button>
              <button title="Discard changes" class="btn btn-danger" @click="toggleEdit()">
                Cancel
              </button>
            </div>
          </div>
        </div>
        <button
          class="btn btn-success ml-auto add-doc"
          @click="showModal = true"
          v-show="currentTab === 'documents-tab'"
        >
          Add Document
        </button>

        <!-- <button class="btn btn-success ml-auto" v-show="currentTab === 'subscriptions-tab'">
          Add Subscription
        </button> -->
      </div>
    </div>

    <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link active"
          id="primary-tab"
          data-toggle="tab"
          href="#primary"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          @click="tabSwitcher($event)"
          ><i data-v-c3127316="" class="fas fa-user d-block d-sm-none"></i> Profile</a
        >
      </li>
      <li class="nav-item" role="presentation" style="position: relative;">
        <a
          class="nav-link"
          id="documents-tab"
          data-toggle="tab"
          href="#documents"
          role="tab"
          aria-controls="documents"
          aria-selected="false"
          @click="tabSwitcher($event)"
          ><i data-v-bd2e2db2="" class="far fa-file-alt d-block d-sm-none"></i> Documents</a
        >
        <div
          v-if="getGuide.show === true && getGuide.step === 3"
          class="guide-box animate__animated animate__fadeIn animate__faster docs"
        >
          <span>Documents</span>
          <p>
            No LinkedIn profile? No problem — just upload your CV here instead.
          </p>
          <div class="buttons">
            <button @click="closeGuide" class="btn btn-danger">Close</button>
            <button @click="nextStep" class="btn btn-primary">Next</button>
          </div>
        </div>
      </li>
      <!--       <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          id="subscriptions-tab"
          data-toggle="tab"
          href="#subscriptions"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
          @click="tabSwitcher($event)"
          ><i class="fas fa-rss d-block d-sm-none"></i> Subscriptions</a
        >
      </li> -->
    </ul>
    <div class="tab-content m-0 c-tab-content" id="myTabContent">
      <div
        class="tab-pane fade show active"
        id="primary"
        role="tabpanel"
        aria-labelledby="primary-tab"
      >
        <div>
          <ul class="list-unstyled profile-info row">
            <li class="col-md-6">
              <div class="edit d-flex align-items-center">
                <span class="edit-label">Email</span>
                <span v-if="!isInEditMode">
                  {{ getUserProfile.email }}
                </span>
                <input
                  disabled
                  v-model="editEmailAddress"
                  v-else
                  type="text"
                  class="form-control"
                />
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center">
                <span class="edit-label">Second email</span>
                <span v-if="!isInEditMode">
                  {{ getUserProfile.email2 }}
                </span>
                <input v-model="editEmailAddress2" v-else type="text" class="form-control" />
              </div>
            </li>
            <li class="col-md-6 user-cand">
              <div class="d-flex align-items-center w-100">
                <span class="edit-label">Phone</span>
                <span v-if="!isInEditMode">
                  {{ getUserProfile.phone }}
                </span>
                <div v-else class="new-phone cand">
                  <v-select
                    :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                    style="font-size: 14px; height: 42px"
                    :clearable="false"
                    placeholder="Country code"
                    v-model="countryCode"
                    @input="addCountryCode(countryCode)"
                  >
                    <template v-slot:option="option">
                      {{ option.label }}
                    </template>
                  </v-select>
                  <input v-model="editPhone" type="text" class="form-control" />
                </div>
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center">
                <span class="edit-label">Street address</span>
                <span v-if="!isInEditMode">
                  {{ getUserProfile.street }}
                </span>
                <input v-model="editStreet" v-else type="text" class="form-control" />
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center">
                <span class="edit-label">Postal Code</span>
                <span v-if="!isInEditMode">
                  {{ getUserProfile.postal }}
                </span>
                <input v-model="editPostal" v-else type="text" class="form-control" />
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center" style="position: relative">
                <span class="edit-label">City</span>
                <span v-if="!isInEditMode">{{ getUserProfile.city }}</span>
                <v-select
                  v-else
                  class="w-100"
                  v-model="cityObj"
                  label="name"
                  :options="[...getCitiesListByCountry]"
                  :reduce="city => city"
                  :clearable="true"
                >
                  <template v-slot:no-options>
                    <div style="opacity: 0.5">Please select a country first</div>
                  </template>
                </v-select>
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center counti">
                <span class="edit-label">Country</span>
                <span v-if="!isInEditMode">{{ getUserProfile.country }}</span>
                <v-select
                  v-else
                  class="w-100"
                  v-model="countryObj"
                  @input="fetchCitiesByCountryId($event)"
                  label="name"
                  :options="[...getAllCountries]"
                  :reduce="lang => lang"
                  :clearable="true"
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching && search.length >= 3">
                      No results found for <em>{{ search }}</em
                      >.
                    </template>
                    <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                  </template>
                </v-select>
              </div>
            </li>

            <li class="col-md-6">
              <div class="d-flex align-items-center">
                <span style="position: relative;" class="edit-label"
                  >LinkedIn

                  <div
                    v-if="getGuide.show === true && getGuide.step === 2"
                    class="guide-box animate__animated animate__fadeIn animate__faster linked"
                  >
                    <span>LinkedIn / Competencies</span>
                    <p class="monte">
                      Add a link to your LinkedIn profile and list your most relevant skills as
                      tags.
                    </p>
                    <div class="buttons">
                      <button @click="closeGuide" class="btn btn-danger">Close</button>
                      <button @click="nextStep" class="btn btn-primary">Next</button>
                    </div>
                  </div>
                </span>
                <span v-if="!isInEditMode">
                  <a rel="nofollow" target="_blank" :href="getUserProfile.linkedin">{{
                    getUserProfile.linkedin
                  }}</a>
                </span>
                <input v-model="editLinkedIn" v-else type="text" class="form-control" />
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center">
                <span class="edit-label">Web page</span>
                <span v-if="!isInEditMode">
                  <a rel="nofollow" target="_blank" :href="getUserProfile.webpage">{{
                    getUserProfile.webpage
                  }}</a>
                </span>
                <input v-model="editWebPage" v-else type="text" class="form-control" />
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center issue">
                <span class="edit-label">Competencies</span>
                <span v-if="!isInEditMode">
                  <ul class="list-inline">
                    <li
                      style="margin-bottom: 0"
                      v-for="competence in getUserProfile.competences"
                      :key="competence.id"
                      class="list-inline-item"
                    >
                      {{ competence.name }}
                    </li>
                  </ul>
                </span>
                <v-select
                  style="width: 100%"
                  v-else
                  v-model="keywords"
                  label="name"
                  @input="pushKeywords($event)"
                  :options="getCompetencesFilterList"
                  :reduce="competence => competence"
                  :clearable="true"
                  multiple
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching && search.length >= 3">
                      No results found for <em>{{ search }}</em
                      >.
                    </template>
                    <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                  </template>
                </v-select>
              </div>
            </li>
            <li class="col-md-6">
              <div class="d-flex align-items-center issue">
                <span class="edit-label">Languages</span>
                <span v-if="!isInEditMode">
                  <ul class="list-inline">
                    <li
                      style="margin-bottom: 0"
                      v-for="lang in getUserProfile.languages"
                      :key="lang.id"
                      class="list-inline-item"
                    >
                      {{ lang.name }}
                    </li>
                  </ul>
                </span>
                <v-select
                  style="width: 100%"
                  v-else
                  v-model="languages"
                  label="name"
                  :options="getLanguagesList"
                  :clearable="true"
                  multiple
                >
                  <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching && search.length >= 3">
                      No results found for <em>{{ search }}</em
                      >.
                    </template>
                    <div style="opacity: 0.5" v-else>Please type at least 3 characters</div>
                  </template>
                </v-select>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="tab-pane fade"
        id="documents"
        role="tabpanel"
        aria-labelledby="documents-tab"
        style="padding: 0"
      >
        <span><AddDocuments @close="showModal = false"/></span>
      </div>
      <div
        class="tab-pane fade"
        id="subscriptions"
        role="tabpanel"
        aria-labelledby="subscriptions-tab"
      >
        <Subscriptions></Subscriptions>
      </div>
    </div>

    <CustomMainModal @close="closeModal" v-show="showModal">
      <template v-slot:header>
        <h5
          v-if="
            getUserProfile.has_uncompleted_applications === true && currentTab !== 'documents-tab'
          "
        >
          Apply for Job
        </h5>
        <h5 v-else>Add Document</h5>
      </template>
      <!--  <AddDocumentsBtnModal @close="showModal = false"></AddDocumentsBtnModal> -->
      <div id="add-document-form">
        <div class="row justify-content-center">
          <div class="col-md-11">
            <Message v-show="errorMessage" class="mt-2" type="error-alert">
              <!-- <h4 slot="heading" class="alert-heading">Something went wrong!</h4> -->
              <p slot="alert-message" class="mb-0">{{ errorMessage }}</p>
            </Message>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-11">
            <div
              class="text-center mb-3"
              v-if="
                getUserProfile.has_uncompleted_applications === true &&
                  currentTab !== 'documents-tab'
              "
            >
              Please add a link to your LinkedIn profile or upload your CV in order to complete the
              application. If you don't want to do this now, click on Finish Later and logon at a
              later time to finish your application.
            </div>

            <input
              v-if="
                getUserProfile.has_uncompleted_applications === true &&
                  currentTab !== 'documents-tab'
              "
              type="text"
              class="form-control mb-3"
              v-model="linkedInUrl"
              placeholder="LinkedIn profile url"
            />

            <form ref="fileForm" enctype="multipart/form-data">
              <div class="dropzone p-4">
                <div class="dropzone-message file-drag-drop">
                  <p class="small drop-files">Upload document here or click to browse for file.</p>

                  <label for="candidate-files" class="btn btn-primary btn-sm file-upload-label mb-0"
                    >Browse</label
                  >
                  <input
                    type="file"
                    id="candidate-files"
                    ref="candidateDocumentsFiles"
                    name="candidateDocumentsFiles"
                    @input="handleCandidateDocumentsFileUpload"
                    class="file-upload-input"
                    accept=".doc,.docx,.pdf,.odt,.jpg,.jpeg,.png,.heic"
                    multiple
                  />

                  <ul class="list-group file-listing mt-3">
                    <li
                      v-for="(file, key) in candidateDocumentsFiles"
                      :key="key"
                      class="list-group-item d-flex align-items-center small"
                    >
                      <span class="mr-auto">{{ file.name }}</span>
                      <span class="badge badge-primary badge-pill ml-auto">{{
                        `${(file.size / 1024 / 1024).toFixed(2)} MB`
                      }}</span>
                      <span class="remove-container ml-4">
                        <span class="remove" style="cursor: pointer" v-on:click="removeFile(key)"
                          >×</span
                        >
                      </span>
                    </li>
                  </ul>

                  <div v-if="uploadPercentage < 100 && isUploading" class="small">
                    <progress max="100" :value.prop="uploadPercentage" />
                    <div>{{ `${uploadPercentage}%` }}</div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row justify-content-center mb-5">
          <div class="col-md-5">
            <div
              v-if="
                getUserProfile.has_uncompleted_applications === true &&
                  currentTab !== 'documents-tab'
              "
              class="text-center mt-3 d-flex"
            >
              <button @click="applyNow" class="btn btn-secondary btn-custom w-50 mr-4">
                Apply Now
              </button>
              <button class="btn btn-primary btn-custom w-50" @click="cancelUpload">
                Finish Later
              </button>
            </div>
            <div v-else class="text-center mt-3 d-flex">
              <button
                :class="candidateDocumentsFiles.length === 0 || isUploading ? 'disabled' : ''"
                @click="submitFiles"
                :disabled="isUploading"
                class="btn btn-secondary btn-custom w-50 mr-4"
              >
                Upload
              </button>
              <button class="btn btn-primary btn-custom w-50" @click="cancelUpload">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </CustomMainModal>
    <!-- Change Avatar Modal -->

    <!-- End Change Avatar Modal -->

    <div v-if="intro" class="on-exit animate__animated animate__fadeIn animate__fast">
      <div class="box">
        <div class="content">
          <span @click="disableIntro" class="close-button">X</span>
          <div class="text">
            <h3>Welcome to Jobshark! Your account is ready to go.</h3>
            <p>
              To start applying for job opportunities, add a link to your LinkedIn profile or upload
              your CV.<br /><br />
              On the <strong>My Profile</strong> page you can also include your relevant skills.
              This will help our recruiters match you with the best job opportunities tailored to
              your expertise.<br /><br />
              Interested in remote freelance work? Join our <strong>Freelancing Network</strong> for
              top tech projects and flexible working hours.
            </p>
          </div>
          <div class="img-holder">
            <img src="https://jobshark.eu/img/shark_welcome.png" alt="welcome shark" />
          </div>
        </div>
        <div class="buttonss">
          <button @click="goToJobs" class="btn btn-secondary">
            Start applying
          </button>
          <button @click="goToFreelancer" class="btn btn-secondary">
            Join the Freelancing Network
          </button>
          <div @click="disableIntro" class="btn btn-danger" style="margin-left: auto;">
            <span>Close</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import FloatLabel from '../common/float-labels/FloatLabel';
import AddDocuments from './AddDocuments';
import Subscriptions from './Subscriptions';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import AvatarPreview from './UserAvatarPreview';
// import { errorService } from '../../services/errorService';

/* import AddDocumentsBtnModal from './AddDocumentsBtnModal'; */

import Message from '../AlertMessages/Message';
import axios from 'axios';

// import moment from 'moment-timezone';

const MAX_FILE_SIZE = 20;

export default {
  components: {
    AvatarPreview,
    Message,
    /*  FloatLabel, */
    AddDocuments,
    Subscriptions,
    CustomMainModal,
    /* AddDocumentsBtnModal, */
  },
  data: () => ({
    intro: false,
    selectedAvatrar: '',
    isLoading: true,
    avatar: null,
    itemId: null,
    dragAndDropCapable: false,
    files: [],
    file: '',
    fileUrl: null,
    uploadPercentage: 0,
    isUploading: false,
    errorMessage: '',
    isPrimary: false,
    isInEditMode: false,
    userProfile: { format_date: 'YY-MM-DD' },
    /* timeZones: [],
    timezone: 'Europe/Sofia (GMT+03:00) ', */
    showModal: false,
    currentTab: 'primary-tab',
    candidateDocumentsFiles: [],
    /* Edit Variables */
    linkedInUrl: '',
    countryCode: '',
    editFirstName: '',
    editLastName: '',
    editEmailAddress: '',
    editEmailAddress2: '',
    editPhone: '',
    editStreet: '',
    editPostal: '',
    editSkype: '',
    editLinkedIn: null,
    editWebPage: null,
    editLanguages: '',
    keywords: [],
    languages: [],
    selectedCountry: '',
    selectedCity: '',
    newKeywords: [],
    editButton: true,
    singleJob: '',
    countryObj: {
      id: '213',
      name: 'Sweden',
    },
    cityObj: {
      id: '103758',
      name: 'Stockholm',
    },
  }),
  methods: {
    ...mapActions([
      'editUserCandidateProfile',
      'retrieveUserProfile',
      'retrieveCompetencesList',
      'retrieveLanguagesList',
      'retrieveCandidateUserProfile',
      'retrieveCitiesListByCountryId',
      'retrieveAllCountries',
      'setCandidateGuideStep',
    ]),
    goToJobs() {
      this.$router.push({ name: 'user-search-jobs' });
    },
    goToFreelancer() {
      this.$router.push({ name: 'freelancing-network' });
    },
    disableIntro() {
      axios(`${process.env.VUE_APP_API_URL}/candidate/updateintroscreen`, {
        method: 'post',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.intro = false;
      });
    },
    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.editPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    reGetProfile() {
      this.retrieveCandidateUserProfile().then(() => {
        this.selectedAvatrar = this.getUserProfile.photo;
      });
    },
    pushKeywords() {
      for (let i = 0; i < this.keywords.length; i++) {
        let item = this.keywords[i];
        if (!item.hasOwnProperty('competence_id')) {
          item.competence_id = item.id;
        } else {
          item.id = item.competence_id;
        }
      }
    },

    applyNow() {
      if (this.candidateDocumentsFiles.length > 0 && this.linkedInUrl.length > 0) {
        this.submitFiles();
      }
      if (this.candidateDocumentsFiles.length > 0 && this.linkedInUrl.length === 0) {
        this.submitFiles();
      }
      if (this.candidateDocumentsFiles.length === 0 && this.linkedInUrl.length > 0) {
        this.updateLinkedIn();
      }
    },

    updateLinkedIn() {
      axios(`${process.env.VUE_APP_API_URL}/candidate/update`, {
        method: 'post',
        data: {
          first_name: this.getUserProfile.first_name,
          last_name: this.getUserProfile.last_name,
          linkedin: this.linkedInUrl,
          city_id: this.getUserProfile.city_id,
          country_id: this.getUserProfile.country_id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(() => {
        this.showModal = false;
      });
    },
    toggleEdit() {
      if (this.isInEditMode === false) {
        if (this.getUserProfile.phone !== null) {
          let extractedNumbers = this.getUserProfile.phone.match(/^(\+\d+)\s/);
          if (extractedNumbers) {
            let countryCode = extractedNumbers[1]; // Extracted numbers before the space
            let exists = this.getAllCountries.find(country => country.phone_code === countryCode);

            if (exists) {
              this.countryCode = exists.name;
            } else {
              this.countryCode = '';
            }
          }
        }
        this.isInEditMode = true;
        this.editFirstName = this.getUserProfile.first_name;
        this.editLastName = this.getUserProfile.last_name;
        this.editEmailAddress = this.getUserProfile.email;
        this.editEmailAddress2 = this.getUserProfile.email2;
        if (this.getUserProfile.phone !== null) {
          this.editPhone = this.getUserProfile.phone;
        } else {
          this.editPhone = '';
        }
        this.editSkype = this.getUserProfile.skype;
        this.editLinkedIn = this.getUserProfile.linkedin;
        this.editWebPage = this.getUserProfile.webpage;
        this.editStreet = this.getUserProfile.street;
        this.editPostal = this.getUserProfile.postal;
        this.getUserProfile.competences.forEach(element => {
          element.id = element.competence_id;
          this.keywords.push(element);
        });
        this.getUserProfile.languages.forEach(element => {
          element.id = element.language_id;
          this.languages.push(element);
        });
      } else {
        this.isInEditMode = false;
        this.keywords = [];
        this.languages = [];
      }
    },

    getActiveIcon(key) {
      if (this.itemId == key && !this.getUserProfile.has_cv) {
        return false;
      } else {
        return true;
      }
    },
    closeModal() {
      this.errorMessage = '';
      this.files = [];
      this.showModal = false;
      this.isLoading = false;
    },
    tabSwitcher(e) {
      switch (e.target.id) {
        case 'documents-tab':
          this.currentTab = 'documents-tab';
          this.isInEditMode = false;
          this.editButton = false;
          this.languages = [];
          this.keywords = [];
          break;
        case 'subscriptions-tab':
          this.currentTab = 'subscriptions-tab';
          break;
        default:
          this.currentTab = 'primary-tab';
          this.editButton = true;
          break;
      }
    },
    editProfile() {
      if (this.cityObj === null && this.countryObj === null) {
        this.$toasted.error(`Please select country and city`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      }
      if (
        this.editLinkedIn !== null &&
        this.editLinkedIn.length > 0 &&
        !this.editLinkedIn.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
        )
      ) {
        this.$toasted.error('Please enter valid LinkedIn profile url', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      }
      if (
        this.editWebPage != null &&
        this.editWebPage.length > 0 &&
        !this.editWebPage.match(
          /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
        )
      ) {
        this.$toasted.error('Please enter valid url for webpage', {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
        return false;
      } else {
        axios(`${process.env.VUE_APP_API_URL}/candidate/update`, {
          method: 'post',
          data: {
            first_name: this.editFirstName,
            last_name: this.editLastName,
            linkedin: this.editLinkedIn,
            phone: this.editPhone,
            webpage: this.editWebPage,
            skype: this.editSkype,
            city_id: this.cityObj.id,
            country_id: this.countryObj.id,
            email2: this.editEmailAddress2,
            competences: this.keywords.map(c => c.id),
            languages: this.languages,
            street: this.editStreet,
            postal: this.editPostal,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        }).then(() => {
          this.retrieveCandidateUserProfile();
          this.isInEditMode = false;
          this.$toasted.success('Profile data saved', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
          this.keywords = [];
          this.languages = [];
        });
      }
    },
    updateUserProfile() {
      this.editUserCandidateProfile(this.userProfile);

      this.setDefaultTimeZone();

      this.$toasted.show(this.getNotificationMessage, {
        theme: 'bubble',
        icon: 'fa-unlock-alt',
        position: 'bottom-right',
        duration: 5000,
      });

      this.isInEditMode = false;
    },
    updateLocalUserProfile(e) {
      this.$set(this.userProfile, e.target.id, e.target.value);
    },

    nextStep() {
      this.setCandidateGuideStep(this.getGuide.step + 1);
    },
    closeGuide() {
      this.$store.commit('SET_GUIDE_SHOW', false);
      this.hideGuide();
    },

    hideGuide() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/candidate/updatetutorial`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(() => {
          this.intro = false;
        });
    },
    setAsDefault(e) {
      console.log(e);
      this.itemId = e.target.id;
    },
    handleFileUpload() {
      const uploadedFiles = this.$refs.files.files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }

      this.$refs.fileForm.reset();
    },
    removeFile(key) {
      this.candidateDocumentsFiles.splice(key, 1);
    },
    cancelUpload() {
      this.isLoading = false;
      this.errorMessage = '';
      this.files = [];
      this.showModal = false;
    },
    determineDragAndDropCapable() {
      let div = document.createElement('div');

      return (
        ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) &&
        'FormData' in window &&
        'FileReader' in window
      );
    },
    handleCandidateDocumentsFileUpload() {
      /* console.log(
        'handleCandidateDocumentsFileUpload: ',
        this.$refs['candidateDocumentsFiles'].files,
      ); */

      const uploadedFiles = this.$refs['candidateDocumentsFiles'].files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.candidateDocumentsFiles.push(uploadedFiles[i]);
      }

      this.$refs.fileForm.reset();

      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i];

        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of 20 MB.`;
        }
      }
    },
    submitFiles() {
      this.isUploading = true;
      const formData = new FormData();

      for (let i = 0; i < this.candidateDocumentsFiles.length; i++) {
        const file = this.candidateDocumentsFiles[i];
        const fileSize = (file.size / 1024 / 1024).toFixed(2);

        if (fileSize > MAX_FILE_SIZE) {
          this.errorMessage = `The file size exceeds the limit of ${MAX_FILE_SIZE} MB.`;
        } else {
          if (
            this.getUserProfile.documents.length === 0 ||
            !this.getUserProfile.documents.some(doc => doc.is_default)
          ) {
            if (this.candidateDocumentsFiles.length > 1) {
              if (i === 0) {
                this.isPrimary = true;
              }
            } else if (this.candidateDocumentsFiles.length === 1 && i === 0) {
              this.isPrimary = true;
            }
          }

          formData.append(`file_${i}`, file);
          formData.append(`primary_${i}`, this.isPrimary);
        }
      }

      formData.append('files_count', this.candidateDocumentsFiles.length);

      if (this.candidateDocumentsFiles.length) {
        axios
          .post(`${process.env.VUE_APP_API_URL}/candidate/documents/upload`, formData, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
              this.uploadPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total),
              );
            },
          })
          .then(() => {
            this.isUploading = false;
            this.uploadPercentage = 0;
            this.errorMessage = '';
            this.retrieveCandidateUserProfile();
            this.showModal = false;
            this.candidateDocumentsFiles = [];
            this.$emit('removeAlert');
            if (this.linkedInUrl.length > 0) {
              this.updateLinkedIn();
            }
          })
          .catch(err => {
            //You can have a maximum of 20 documents
            if (err.response.data === 'You can have a maximum of 20 documents') {
              this.$toasted.error(`Document limit reached. Delete existing ones to add more`, {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            } else {
              this.$toasted.error(`${err}`, {
                theme: 'bubble',
                icon: 'fa-check-circle',
                position: 'bottom-right',
                duration: 5000,
              });
            }
            this.isUploading = false;
            this.uploadPercentage = 0;
          });
      }
    },
    fetchCitiesByCountryId(e) {
      this.selectedCountry = e;
      // this.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.selectedCountry.id });
    },
    getSingleJob() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/candidate/viewjob/${this.$route.params.jobad_id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.isLoading = false;
          this.singleJob = data;
          this.city = data.address.city.name;
          this.country = data.address.country.name;
          this.jobId = data.id;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters([
      'getUserProfile',
      'getNotificationMessage',
      'isTokenExpired',
      'getCandidateDocuments',
      'getCompetencesFilterList',
      'getLanguagesList',
      'getAllCountries',
      'getCitiesListByCountry',
      'getGuide',
    ]),
  },
  mounted() {
    localStorage.setItem('UserJobList', 1);
    localStorage.setItem('UserSearchLocation', []);
    localStorage.setItem('UserSearchKeywords', []);
    localStorage.setItem('UserSearchEmployer', []);
    this.retrieveCandidateUserProfile().then(() => {
      this.newKeywords = this.getUserProfile.competences;
      this.countryObj.id = this.getUserProfile.country_id;
      this.countryObj.name = this.getUserProfile.country;
      this.cityObj.id = this.getUserProfile.city_id;
      this.cityObj.name = this.getUserProfile.city;
      this.selectedAvatrar = this.getUserProfile.photo;

      if (sessionStorage.getItem('first') !== '1') {
        this.$toasted.success(`Welcome back, ${this.getUserProfile.first_name}!`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      }
      sessionStorage.setItem('first', '1');
      if (this.getUserProfile.tutorial) {
        setTimeout(() => {
          this.$store.commit('SET_GUIDE_SHOW', true);
        }, 3000);
      }
      if (
        this.getUserProfile.completed === false &&
        this.getUserProfile.uncompleted_job_id !== null
      ) {
        this.showModal = true;
      }
      if (this.getUserProfile.intro_screen && this.getUserProfile.uncompleted_job_id === null) {
        this.intro = true;
      }
      this.isLoading = false;
      if (localStorage.getItem('applyId')) {
        this.$router.push({
          name: 'user-jobs',
          params: { jobad_id: localStorage.getItem('applyId') },
        });
      }
    });

    this.retrieveLanguagesList();
    this.retrieveCompetencesList();
    this.dragAndDropCapable = this.determineDragAndDropCapable();
    this.$nextTick(() => {
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(
          event => {
            this.$refs.fileForm.addEventListener(
              event,
              e => {
                e.preventDefault();
                e.stopPropagation();
              },
              false,
            );
          },
        );

        this.$refs.fileForm.addEventListener('drop', e => {
          for (let i = 0; i < e.dataTransfer.files.length; i++) {
            this.files.push(e.dataTransfer.files[i]);
          }
        });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';
@import '@/assets/scss/_mixins';
/* Default select doc icon */
@include select-default-document-icon-styles;

.buttonss {
  gap: 14px;
  display: flex;
}

.guide-box {
  background-color: #eeeded;
  position: absolute;
  left: 0;
  top: 0;
  padding: 20px;
  width: 320px;
  z-index: 9999;
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
  .monte {
    font-weight: 400 !important;
    font-family: Montserrat, Roboto, 'Helvetica Neue', Arial, sans-serif;
  }
  span {
    font-size: 18px;
    display: block;
    font-weight: 600;
    margin-bottom: 15px;
  }
  img {
    max-width: 100%;
    height: auto;
  }
  p {
    font-size: 14px;
  }
  .buttons {
    display: flex;
    gap: 15px;
    .btn {
      flex: 1;
      font-size: 13px;
    }
  }
  &.linked {
    left: 120%;
    top: -50px;
    &:before {
      content: '';
      position: absolute;
      top: 50%; /* center vertically */
      left: -18px; /* place to the left of the element */
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-right: 17px solid #eeeded; /* same as .linked background color */
    }
  }

  &.docs {
    left: 115%;
    top: -70px;
    &:before {
      content: '';
      position: absolute;
      top: 50%; /* center vertically */
      left: -18px; /* place to the left of the element */
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-bottom: 13px solid transparent;
      border-right: 17px solid #eeeded; /* same as .linked background color */
    }
  }
}

.on-exit {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999999;
  .box {
    width: 55%;
    max-width: 1250px;
    background: #fff;
    border-radius: 22px;
    border: 1px solid #ddd;
    padding: 22px;
    position: relative;
    background-color: #fff;
    .content {
      position: relative;
      display: flex;
      .close-button {
        position: absolute;
        top: 0px;
        right: 20px;
        cursor: pointer;
        font-weight: 900;
        color: #666;
      }
      .text {
        padding: 30px 20px 30px 0;
        flex: 1;
        flex-shrink: 0;
        h3 {
          font-weight: 900;
          color: #f26622;
          font-size: 26px;
          margin-bottom: 20px;
        }
        h4 {
          font-size: 16px;
          font-weight: 700;
        }
        p {
          font-size: 15px;
        }
        .list-unstyled {
          list-style: disc !important;
          font-size: 15px;
          padding-left: 25px;
          li {
            margin-bottom: 12px;
            font-size: 14px;
          }
        }
        .btn-secondary {
          padding: 8px 30px;
          font-size: 16px;
          font-weight: 500;
          flex: 1;
          &:first-of-type {
            margin-right: 12px;
          }
        }
      }

      .img-holder {
        width: 45%;
        img {
          width: 100%;
          height: auto;
        }
      }
      .dont {
        text-align: center;
        margin-top: 12px;
        font-size: 13px;
        color: rgb(0, 136, 204);
        cursor: pointer;
      }
    }
  }
}

.v-select,
.vs--multiple,
.vs--searchable {
  .vs__dropdown-toggle {
    border: none !important;
    .vs__selected-options {
      border: none !important;
    }
  }
}

select {
  font-family: $font-family-sans-lato;
  font-size: 10px;
}

.form-group.required {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-aligment {
  position: relative;
  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 26px;
    color: red;
    opacity: 0.6;
  }
}

.vfl-has-label {
  input {
    height: 3.2rem !important;
  }
}

.edit {
  margin-bottom: 30px;
  padding-right: 18px;
  .avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    margin-right: 16px;
    img {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      object-fit: cover;
      cursor: pointer;
    }
  }
}

.form-buttons {
  .btn {
    padding: 6px 12px;
    text-align: center;
    box-shadow: none !important;
  }
}

.modal-header {
  padding: 12px 17px 0 22px;
}

.map-responsive {
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
  margin-bottom: 30px;
  border: 1px solid #ddd;

  iframe {
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    position: absolute;
  }
}

.change-avatar {
  position: relative;
  display: block;
  margin: 12px auto;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
}

.nav-tabs {
  margin-left: 1rem;
  margin-right: 1rem;
}

.tab-content {
  padding: 0 20px;
}

.nav-item {
  margin-right: 3px;
  a {
    color: #a3a6b4;
    font-size: 0.8rem;
    border: 1px solid #e2e2e2;
    background: #f5f5f5;
    font-weight: 700;
    text-transform: uppercase;
  }
}
.no-mobile {
  display: block;
}

@media only screen and (max-width: 1251px) {
  .guide-box {
    display: none !important;
  }
}

@media only screen and (max-width: 1600px) {
  .guide-box {
    display: none !important;
  }
  .on-exit {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    .box {
      background: #fff;
      border-radius: 22px;
      border: 1px solid #ddd;
      padding: 22px;
      position: relative;
      background-color: #fff;
      overflow-y: auto;
      .content {
        position: relative;
        display: flex;
        .close-button {
          position: absolute;
          top: 0px;
          right: 20px;
          cursor: pointer;
          font-weight: 900;
          color: #666;
        }
        .text {
          padding: 30px 20px 30px 0;
          flex: 1;
          flex-shrink: 0;
          h3 {
            font-weight: 900;
            color: #f26622;
            font-size: 18px;
            margin-bottom: 20px;
          }
          h4 {
            font-size: 14px;
            font-weight: 700;
          }
          p {
            font-size: 14px;
          }
          .list-unstyled {
            list-style: disc !important;
            font-size: 14px;
            padding-left: 25px;
            li {
              margin-bottom: 12px;
              font-size: 14px;
            }
          }
          .buttonss {
            display: block !important;
          }
          .btn-secondary {
            padding: 8px 30px;
            font-size: 16px;
            font-weight: 500;
            display: block;
            width: 100%;
            &:first-of-type {
              margin-right: 12px;
              margin-bottom: 15px;
            }
          }
        }
        .img-holder {
          display: none;
        }
        .dont {
          text-align: center;
          margin-top: 12px;
          font-size: 13px;
          color: rgb(0, 136, 204);
          cursor: pointer;
        }
      }
    }
  }
}

@media only screen and (max-width: 920px) {
  .on-exit {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    padding-top: 50px;
    padding-bottom: 50px;
    overflow: hidden;
    .box {
      height: 95%;
      width: 95%;
      background: #fff;
      border-radius: 22px;
      border: 1px solid #ddd;
      padding: 22px;
      position: relative;
      background-color: #fff;
      overflow: hidden;
      overflow-y: auto;
      .content {
        position: relative;
        display: block;
        .close-button {
          position: absolute;
          top: 0px;
          right: 20px;
          cursor: pointer;
          font-weight: 900;
          color: #666;
        }
        .text {
          padding: 30px 20px 30px 0;
          flex: 1;
          flex-shrink: 0;
          h3 {
            font-weight: 900;
            color: #f26622;
            font-size: 18px;
            margin-bottom: 20px;
          }
          h4 {
            font-size: 14px;
            font-weight: 700;
          }
          p {
            font-size: 14px;
          }
          .list-unstyled {
            list-style: disc !important;
            font-size: 14px;
            padding-left: 25px;
            li {
              margin-bottom: 12px;
              font-size: 14px;
            }
          }
          .buttonss {
            display: block !important;
          }
          .btn-secondary {
            padding: 8px 30px;
            font-size: 16px;
            font-weight: 500;
            display: block;
            width: 100%;
            &:first-of-type {
              margin-right: 12px;
              margin-bottom: 15px;
            }
          }
        }
        .img-holder {
          display: none;
        }
        .dont {
          text-align: center;
          margin-top: 12px;
          font-size: 13px;
          color: rgb(0, 136, 204);
          cursor: pointer;
        }
      }
    }
  }
}

@media only screen and (max-width: 992px) {
  .buttonss {
    display: block !important;
    .btn {
      display: block;
      width: 100%;
      margin-bottom: 12px;
    }
  }
}

@media only screen and (max-width: 576px) {
  .add-doc {
    margin: 12px auto !important;
  }
  .edit {
    padding-right: 0;
    .d-flex {
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      .text {
        width: 100%;
        text-align: center;
      }
      .form-control {
        margin: 0 0 12px 0 !important;
      }
    }
  }
  #profile-content {
    .profile-info {
      li {
        margin: 0 !important;
      }
    }
  }
  .tab-content {
    padding: 0;
    margin-bottom: 50px !important;
  }
  .nav-tabs {
    background: #fff;
    border: none;
    border-top: 1px solid #ddd;
    padding: 12px 0px;
    margin: 0 !important;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    a {
      background: none;
      border: none;
      text-align: center;
      text-transform: uppercase;
      display: block;
      overflow: hidden;
      font-weight: 600;
      padding: 0;
      i {
        margin-bottom: 3px;
      }
    }
  }
  .no-mobile {
    display: none;
  }
}
</style>
